export default {
  200: '정상적으로 이미지가 업로드 되었습니다.',
  401: '이미지 업로드 권한이 없습니다. 관리자에게 문의해주세요.',
  402: '업로드 하기 위해서 결제가 필요합니다.',
  403: '이미지 업로드가 실패하였습니다. 다시 한번 이미지를 확인해주세요.',
  404: '이미지 업로드에 실패하였습니다. 다시 한번 이미지를 확인해주세요.',
  412: '상세 페이지에 기입하지 않은 요소가 있습니다.',
  500: '서버에 오류가 발생하여 요청을 수행할 수 없습니다.',
  501: '서버에 요청을 수행할 수 있는 기능이 없습니다.',
  502: '서버에서 잘못된 응답을 받았습니다.',
  503: '서비스가 현재 패치중입니다.',
  504: '서버 연결이 시간초과 되었습니다.',
  505: '서버가 요청에 사용된 HTTP 프로토콜 버전을 지원하지 않습니다.',
};



// WEBPACK FOOTER //
// ./src/vuex/handler/messages/upload-messages.js